import React from 'react';
import { LOAN_STATUS_LABELS, statusColorHex } from '../losApi';

// Unknown statuses print as a title-cased key ("on_hold" -> "On Hold").
const titleCase = (key) => String(key || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// Loan status as a pill: colour dot + label, tinted from the same hex as the loan list's
// status diamond. Used wherever a raw `loan.status` key would otherwise be printed.
export default function LoanStatusChip({ status }) {
  const hex = statusColorHex(status);
  const label = LOAN_STATUS_LABELS[status] || titleCase(status) || 'Unknown';
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold text-slate-800"
      style={{ background: `${hex}1a`, borderColor: `${hex}66` }}
      data-testid={`loan-status-chip-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: hex }} />
      {label}
    </span>
  );
}
